import {
	createApp
} from 'vue'
import store from './store'
import api from './utils/index.js'
import './assets/css/style.css'
import App from './App.vue'
import router from './router'
// let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
// let isOpera = userAgent.indexOf("Opera") > -1;
// if (userAgent.indexOf("Firefox") > -1) {
// 	document.getElementsByTagName('html')[0].setAttribute('style', 'font-size: 12px;')
// 	console.log(document.getElementsByTagName('html'))
// } //判断是否Firefox浏览器
// if (userAgent.indexOf("Chrome") > -1) {
// 	document.getElementsByTagName('html')[0].setAttribute('style', 'font-size: 10px;')
// 	console.log(document.getElementsByTagName('html'))

// }

const app = createApp(App)

app.config.globalProperties.$api = api

app.use(store)
app.use(router)
app.mount('#app')
